import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { CATEGORIES } from '../data/constants';
import { useApp } from '../context/AppContext';
import { LOCALES } from '../lib/i18n';
import { useApi } from '../hooks/useApi';

const CategoryGrid = () => {
  const { t, lang } = useApp();
  const { data: counts } = useApi('/categories');
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h2 className="text-3xl md:text-4xl font-black tracking-tight text-[#1A1A1A]">{t('cat.title')}</h2>
          <p className="text-[#7A7468] mt-2">{t('cat.subtitle')}</p>
        </div>
        <Link to="/marketplace" className="hidden md:inline-flex text-sm font-semibold text-[#0F8B5C] hover:underline">{t('cat.viewAll')} →</Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {CATEGORIES.map((cat) => {
          const Icon = Icons[cat.icon] || Icons.Tag;
          return (
            <Link key={cat.id} to={`/marketplace?cat=${cat.id}`} data-testid={`category-card-${cat.id}`} className="group relative bg-white rounded-2xl p-5 border border-[#EFEAE0] hover:border-transparent hover:shadow-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden">
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: `linear-gradient(135deg, ${cat.color}08 0%, ${cat.color}02 100%)` }} />
              <div className="relative">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-3 transition-transform group-hover:scale-110" style={{ backgroundColor: `${cat.color}15`, color: cat.color }}>
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <h3 className="font-semibold text-sm text-[#1A1A1A] leading-tight">{cat.name[lang] || cat.name.en}</h3>
                <p className="text-xs text-[#7A7468] mt-1">{(counts?.[cat.id] ?? 0).toLocaleString(LOCALES[lang])} {t('cat.items')}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default CategoryGrid;
